import { FC, PropsWithChildren, ReactNode } from 'react'

import { createTestId } from 'aem-libs-tests/src/utility/createTestId'

import { MarginProps } from '../../../../../styles/margin'
import * as ResultSimpleRowStyled from './ResultSimpleRow.styled'

export type RowDirection = 'column' | 'row'

const defaultGrow = 2

export interface ResultSimpleRowProps extends MarginProps {
  label?: string | ReactNode
  direction?: RowDirection
  withBorder?: boolean
  background?: 'default' | 'grey'
  className?: string
  flexGrow?: number
  ignoreRadius?: boolean
  onClick?: () => void
  testId?: string
  lineHeight?: 'default' | 'xs'
  id?: string
}

export const ResultSimpleRow: FC<PropsWithChildren<ResultSimpleRowProps>> = ({
  label,
  className,
  children,
  direction = 'row',
  withBorder,
  background = 'default',
  flexGrow = defaultGrow,
  ignoreRadius,
  onClick,
  testId,
  lineHeight,
  id,
  ...marginProps
}) => {
  const usedTestId = testId ?? 'result-simple-row'

  return (
    <ResultSimpleRowStyled.Container
      className={className}
      withBorder={withBorder}
      background={background}
      flexGrow={flexGrow}
      ignoreRadius={ignoreRadius}
      clickable={Boolean(onClick)}
      data-testid={usedTestId}
      {...onClick && {
        onClick: onClick
      }}
      {...marginProps}
    >
      <ResultSimpleRowStyled.Content
        flexDirection={direction}
        withBorder={withBorder}
        background={background}
        lineHeight={lineHeight}
      >
        {label && (
          <ResultSimpleRowStyled.Label
            id={id}
            $flexDirection={direction}
            data-testid={createTestId(usedTestId, 'label')}
          >
            {label}
          </ResultSimpleRowStyled.Label>
        )}
        <ResultSimpleRowStyled.Value id={'simple-row__value'} data-testid={createTestId(usedTestId, 'content')}>
          {children}
        </ResultSimpleRowStyled.Value>
      </ResultSimpleRowStyled.Content>
    </ResultSimpleRowStyled.Container>
  )
}
